import { render, staticRenderFns } from "./addmouthcar.vue?vue&type=template&id=f0bedf24&"
import script from "./addmouthcar.vue?vue&type=script&lang=js&"
export * from "./addmouthcar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports